import { render, staticRenderFns } from "./oneselfCommissionBill.vue?vue&type=template&id=afdd9dd6&scoped=true&"
import script from "./oneselfCommissionBill.vue?vue&type=script&lang=js&"
export * from "./oneselfCommissionBill.vue?vue&type=script&lang=js&"
import style0 from "./oneselfCommissionBill.vue?vue&type=style&index=0&id=afdd9dd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afdd9dd6",
  null
  
)

component.options.__file = "oneselfCommissionBill.vue"
export default component.exports